import { STAGE } from './config';
export const getBaseURL = () => {
  return (
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '')
  );
};

export const FILE_TYPES =
  '.jpg,.png,.gif,.jpeg,.pdf,.mp4,.mpeg,.webm,.ogg,.wav,.vcf,.doc,.docx,.xls,.xlsx,.csv,.txt,.text';

export const ADMIN_ACCOUNT = '9287';

export const EMPTY_TIMESTAMP = '0000-00-00 00:00:00';
export const EMPTY_TIME = '00:00:00';

export const BrandLabel = {
  TMG: 'Text My Gym',
  TIC: 'Text In Church',
  get(brand) {
    return this[brand.toUpperCase()];
  },
};

export const BrandIcons = {
  TMG: 'svg/tmg-logo-blue.svg',
  TIC: 'images/text-in-church-app-icon.png',
  get(brand) {
    return this[brand.toUpperCase()];
  },
};

export const BUCKET_URL = 'https://textinchurchattachments.s3.amazonaws.com/';

export const DCC = {
  prod: 'https://connect-card.com',
  qa: 'https://qa.connect-card.com',
  get URL() {
    return this[STAGE];
  },
  get scriptUrl() {
    return this.URL + '/tic-dcc.js';
  },
};

export const LANGUAGES = [
  { label: 'English', value: 'English' },
  { label: 'French', value: 'French' },
  { label: 'Spanish', value: 'Spanish' },
  { label: 'Other', value: 'Other' },
];
